/**
 * ModuleGate — видимость виджета по реестру «Видимость витрины»
 * (US-09 FR-1): выключенный супер-администратором виджет **не рендерится
 * вовсе** — ни каркасом, ни состоянием «нет данных».
 *
 * Обёртка вокруг `useModulePresent` для мест, где гейтится готовый кусок
 * JSX (карточка, плашка, строка таблицы); там, где флаг нужен в логике
 * (например, чтобы не запрашивать данные), используется сам хук.
 *
 * `id` берётся из `src/consts/modules.ts` — там же список всех виджетов
 * витрины и правило совпадения с реестром бэкенда.
 */
import type { ReactNode } from 'react';

import { useModulePresent } from '../../hooks/useModulePresent';

interface ModuleGateProps {
  /** `module_id` виджета (константа из `MODULES`). */
  id: string;
  children: ReactNode;
}

export const ModuleGate = ({ id, children }: ModuleGateProps) => {
  const present = useModulePresent(id);
  return present ? <>{children}</> : null;
};
